import React, { useState } from "react";
import baseURL from "../../config";
import { Box, Typography, Button, CircularProgress } from "@mui/material";

const UploadSeaServiceForm = ({ selectedItem, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("Please select a PDF");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("contractId", selectedItem.contractDetails?._id);
      formData.append("crewingAgentId", selectedItem.contractDetails?.crewingAgent?._id);
      formData.append("CrewName", selectedItem?.contractDetails?.crewName);
      formData.append("uploadedBy", "Admin");
      formData.append("seaServicePdf", file);

      const res = await fetch(`${baseURL}/api/manualSeaService`, {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        alert("Uploaded successfully");
        onSuccess();
      } else {
        alert("Upload failed");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "100%",
      }}
    >
      <Typography variant="h6" fontWeight="bold">
        Upload Sea Service PDF
      </Typography>

      {/* File Upload Box */}
      <Box
        sx={{
          border: "2px dashed #ccc",
          borderRadius: "8px",
          padding: 2,
          textAlign: "center",
          cursor: "pointer",
          "&:hover": { borderColor: "#1976d2" },
        }}
      >
        <input
          type="file"
          accept="application/pdf"
          style={{ display: "none" }}
          id="upload-pdf"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <label htmlFor="upload-pdf" style={{ cursor: "pointer" }}>
          <Typography variant="body2" color="textSecondary">
            {file ? file.name : "Click to upload PDF"}
          </Typography>
        </label>
      </Box>

      {/* Upload Button */}
      <Button
        type="submit"
        variant="contained"
        disabled={loading}
        fullWidth
      >
        {loading ? <CircularProgress size={20} /> : "Upload"}
      </Button>
    </Box>
  );
};

export default UploadSeaServiceForm;